// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name = \"withUniResizableColumn\"] .uni-resizer {\r\n\t\twidth: 5px;\r\n\t\tposition: relative;\r\n\t\tright: 2px;\r\n\t  }\r\n\t  [name = \"withUniResizableColumn\"] .uni-resize-seperator {\r\n\t\twidth: 2px;\r\n\t\theight: 100%;\r\n\t\tposition: fixed;\r\n\t\tbackground-color: var(--primary-font-color);;\r\n\t\tz-index: 999;\r\n\t  }\r\n\t  [name = \"withUniResizableColumn\"] .uni-resize-bg {\r\n\t\t  left: 0px;\r\n\t  }\r\n\r\n  ", ""]);
// Exports
module.exports = exports;
